document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.sms-support-label').forEach((label) => {
    label.parentNode.href = label.parentNode.href.replace('tel:', 'sms:');
  });
});

getDeviceType = function() {
  if(window.innerWidth < 1000 ) {
    return 'Mobile';
  } else {
    return 'Desktop';
  };
};
